export enum MappingBuilderPage {
    Designer = "Designer",
    InputData = "Input Data",
    OutputData = "Output Data",

    Test = "Test",
}
